import { FundraisingBankDetailsType, INewFundraisingUploadBankDetailsForm } from './types';

export const fundraisingBankDetailsFormDefaults: INewFundraisingUploadBankDetailsForm = {
  bankDetailsType: FundraisingBankDetailsType.DEFAULT,
  bankDetailsFile: undefined,
};
